import type { ReactNode } from 'react';

import './TextWithInput.scss';

type SwitchableInputProps = {
  inputField: ReactNode;
  beforeText?: string;
  afterText?: string;
};

export const TextWithInput = ({
  inputField,
  beforeText,
  afterText,
}: SwitchableInputProps) => {
  return (
    <div className="text-with-input-container">
      <span>{beforeText}</span>
      {inputField}
      <span>{afterText}</span>
    </div>
  );
};
